import { render, staticRenderFns } from "./ConvertAccount.vue?vue&type=template&id=67c4bf86"
import script from "./ConvertAccount.vue?vue&type=script&lang=js"
export * from "./ConvertAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports